import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue"
import StaffDetailPage from "@/modules/Missions/pages/StaffDetailPage/StaffDetailPage.vue"
import ClientDetailPage from "@/modules/Missions/pages/ClientDetailPage/ClientDetailPage.vue"
import { useAccountContext } from "@/hooks/useAccountContext"
import ConsultantDetailPage from "@/modules/Missions/pages/ConsultantDetailPage/ConsultantDetailPage.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'MissionDetail',
  setup(__props) {

const { isClient, isConsultant, isStaff } = useAccountContext()

const isUserStaff = computed(() => isStaff)
const isUserConsultant = computed(() => isConsultant)

return { __sfc: true,isClient, isConsultant, isStaff, isUserStaff, isUserConsultant, StaffDetailPage, ClientDetailPage, ConsultantDetailPage }
}

})